import React, { useState } from "react";
import SubmissionForm from "../components/SubmissionForm";
import SubmissionGuidelinesModal from "../components/SubmissionGuidelinesModal";
import { FileText } from "lucide-react";
import "./SubmissionFormPage.css";

const SubmissionFormPage = () => {
  const [showGuidelines, setShowGuidelines] = useState(true);

  return (
    <div className="submission-page-container">
      {showGuidelines && (
        <SubmissionGuidelinesModal onClose={() => setShowGuidelines(false)} />
      )}

      <div className="submission-page-header">
        <FileText size={30} className="submission-icon" />
        <h1 className="page-title">Submit Your Film</h1>
        <p className="submission-intro">
          Fill out the form below to submit your film for the current Short Cuts
          challenge. Be sure to include all required information about your film
          and team.
        </p>
      </div>

      <div className="form-container">
        <SubmissionForm />
      </div>
    </div>
  );
};

export default SubmissionFormPage;
